<style scoped lang="less">
@import './style.less';
</style>
<script>
import methods from './methods.js'

export default {
  name: "downcastTracking",
  mixins: [methods]
}
</script>
<template>
  <div class="downcastTracking">
<!--    头部-->
    <div class="downcastTracking__head">
      <div class="downcastTracking__head__button">
        <img class="downcastTracking__head__button__icon" src="https://s6.bihukankan.com/img/16912245331.png" />
        <div class="downcastTracking__head__button__label">下播追踪</div>
      </div>
      <div class="downcastTracking__head__title">持续跟踪下播后数据</div>
      <div class="downcastTracking__head__tips">(新功能8.15后生效)</div>
    </div>
<!--    内容-->
    <div class="downcastTracking__content">
<!--      左侧-->
      <div class="downcastTracking__content__item">
        <div class="downcastTracking__content__item__value">{{twoHour.value}}</div>
        <div class="downcastTracking__content__item__bottom">
          <div class="downcastTracking__content__item__bottom__label">2小时后</div>
          <template v-if="twoHour.percentStyle !== PERCENT_STYLE_ENUM.hidden">
            <img class="downcastTracking__content__item__bottom__icon" :src="NARROW_MAP[twoHour.percentStyle]"/>
            <div
                class="downcastTracking__content__item__bottom__percent"
                :class="`downcastTracking__content__item__bottom__percent-${PERCENT_STYLE_ENUM[twoHour.percentStyle]}`"
            >{{twoHour.percentValue}}</div>
          </template>
        </div>
      </div>
<!--      分割线-->
      <div class="downcastTracking__content__divider" />
<!--      右侧-->
      <div class="downcastTracking__content__item">
        <div class="downcastTracking__content__item__value">{{twentyFourHour.value}}</div>
        <div class="downcastTracking__content__item__bottom">
          <div class="downcastTracking__content__item__bottom__label">24小时后</div>
          <template v-if="twentyFourHour.percentStyle !== PERCENT_STYLE_ENUM.hidden">
            <img class="downcastTracking__content__item__bottom__icon" :src="NARROW_MAP[twentyFourHour.percentStyle]"/>
            <div
                class="downcastTracking__content__item__bottom__percent"
                :class="`downcastTracking__content__item__bottom__percent-${PERCENT_STYLE_ENUM[twentyFourHour.percentStyle]}`"
            >{{twentyFourHour.percentValue}}</div>
          </template>
        </div>
      </div>
    </div>
    <!--  付费按钮  -->
    <div class="downcastTracking__pay" v-if="notYearVip">
      <van-button @click="goToOpenVIP" href="/dredgeVip" class="downcastTracking__pay__button" >升级专业版年费解锁内容</van-button>
    </div>

  </div>
</template>

